import {
  TimelineAccomodationsIcon,
  TimelineBeautyIcon,
  TimelineCafeIcon,
  TimelineClassIcon,
  TimelineEtcIcon,
  TimelineHospitalIcon,
  TimelineLeisureIcon,
  TimelineLivingIcon,
  TimelineNatureIcon,
  TimelineRentalIcon,
  TimelineRestaurantIcon,
  TimelineShoppingIcon,
  TimelineSportIcon,
  TimelineTrainIcon,
  TimelineTravelIcon,
} from '@local/assets/icons'
import {
  MarkerPensionIcon,
  MarkerHairShopIcon,
  MarkerHospitalIcon,
  MarkerNailShopIcon,
  MarkerRestaurantIcon,
  MarkerPlaceDotIcon,
  MarkerCafeIcon,
  MarkerPubIcon,
} from '@local/assets/icons/marker-cleanup'
import { isEmptyArray } from '@local/utils'

import { ValueOf } from '@web/types'

export enum BusinessCategory {
  DEFAULT = '',
  CAFE = '220052',
  PUB = '220051',
  HAIR_SHOP = '223288',
  NAIL_SHOP = '223296',
  RESTAURANT = '220036',
  ACCOMMODATION = '221941',
  HOSPITAL = '223176',
}

export const MarkerIconMap = {
  [BusinessCategory.DEFAULT]: MarkerPlaceDotIcon,
  [BusinessCategory.ACCOMMODATION]: MarkerPensionIcon,
  [BusinessCategory.HAIR_SHOP]: MarkerHairShopIcon,
  [BusinessCategory.HOSPITAL]: MarkerHospitalIcon,
  [BusinessCategory.NAIL_SHOP]: MarkerNailShopIcon,
  [BusinessCategory.RESTAURANT]: MarkerRestaurantIcon,
  [BusinessCategory.CAFE]: MarkerCafeIcon,
  [BusinessCategory.PUB]: MarkerPubIcon,
}

export const convertCategoryToMapMarkerIcon = ({
  categoryList,
}: {
  categoryList: string[]
}): ValueOf<typeof MarkerIconMap> => {
  if (isEmptyArray(categoryList)) {
    return MarkerIconMap[BusinessCategory.DEFAULT]
  }

  const businessCategoryList = Object.values(BusinessCategory)

  const category = businessCategoryList.find(category => categoryList.includes(category))
  return category ? MarkerIconMap[category] : MarkerIconMap[BusinessCategory.DEFAULT]
}

export enum TimelineCategoryCode {
  /** 음식점 */
  RESTAURANT = 'restaurant',
  /** 카페 */
  CAFE = 'cafe',
  /** 숙박 */
  ACCOMMODATION = 'accommodation',
  /** 공연/전시 */
  ARTS = 'arts',
  /** 스포츠/오락 */
  SPORTS = 'sports',
  /** 레저/체험 */
  ACTIVITY = 'activity',
  /** 여행/명소 */
  TOUR = 'tour',
  /** 건강/의료 */
  HEALTH = 'health',
  /** 뷰티 */
  BEAUTY = 'beauty',
  /** 생활/편의 */
  CONVENIENCE = 'convenience',
  /** 쇼핑/유통 */
  SHOPPING = 'shopping',
  /** 장소 대여 */
  SPACE_RENTAL = 'space_rental',
  /** 자연 */
  NATURE = 'nature',
  /** 승차권 */
  TICKET = 'ticket',
  /** 기타 */
  ETC = 'etc',
}

export const TimelineCategoryMarkerIconMap = {
  [TimelineCategoryCode.ACCOMMODATION]: TimelineAccomodationsIcon,
  [TimelineCategoryCode.ACTIVITY]: TimelineLeisureIcon,
  [TimelineCategoryCode.ARTS]: TimelineClassIcon,
  [TimelineCategoryCode.BEAUTY]: TimelineBeautyIcon,
  [TimelineCategoryCode.CAFE]: TimelineCafeIcon,
  [TimelineCategoryCode.CONVENIENCE]: TimelineLivingIcon,
  [TimelineCategoryCode.ETC]: TimelineEtcIcon,
  [TimelineCategoryCode.HEALTH]: TimelineHospitalIcon,
  [TimelineCategoryCode.NATURE]: TimelineNatureIcon,
  [TimelineCategoryCode.RESTAURANT]: TimelineRestaurantIcon,
  [TimelineCategoryCode.SHOPPING]: TimelineShoppingIcon,
  [TimelineCategoryCode.SPACE_RENTAL]: TimelineRentalIcon,
  [TimelineCategoryCode.SPORTS]: TimelineSportIcon,
  [TimelineCategoryCode.TICKET]: TimelineTrainIcon,
  [TimelineCategoryCode.TOUR]: TimelineTravelIcon,
}

export const convertToCategoryTagIcon = (categoryTag?: string | null) => {
  if (!categoryTag) return TimelineCategoryMarkerIconMap[TimelineCategoryCode.ETC]

  return (
    TimelineCategoryMarkerIconMap[categoryTag as keyof typeof TimelineCategoryMarkerIconMap] ||
    TimelineCategoryMarkerIconMap[TimelineCategoryCode.ETC]
  )
}
